import React from "react";
import "./FindProfessional.css";
import {
  FaSearch,
  FaMapMarkerAlt,
  FaThLarge,
  FaStar,
  FaPhoneAlt,
  FaEnvelope,
  FaArrowRight
} from "react-icons/fa";

function FindProfessional() {
  return (
    <>

      {/* =====================================
              HERO SECTION
      ===================================== */}

      <section
        className="cc-find-hero"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1920&q=80')",
        }}
      >

        <div className="cc-find-overlay">

          <span>Find Trusted Professionals</span>

          <h1>
            Discover Skilled Experts
            <br />
            Near Your Location
          </h1>

          <p>
            Connect with verified builders, architects,
            interior designers, contractors and real estate
            professionals across India.
          </p>

          <button>
            Explore Professionals
          </button>

        </div>

      </section>



      {/* =====================================
              SEARCH FILTER
      ===================================== */}

      <section className="cc-find-search">

        <div className="cc-find-search-box">

          <div className="cc-find-input">

            <FaSearch className="cc-find-icon"/>

            <input
              type="text"
              placeholder="Search Professionals"
            />

          </div>

          <div className="cc-find-input">

            <FaMapMarkerAlt className="cc-find-icon"/>

            <select>

              <option>Zirakpur</option>
              <option>Chandigarh</option>
              <option>Mohali</option>
              <option>Panchkula</option>

            </select>

          </div>

          <div className="cc-find-input">

            <FaThLarge className="cc-find-icon"/>

            <select>

              <option>All Categories</option>

              <option>Builder</option>

              <option>Architect</option>

              <option>Interior Designer</option>

              <option>Property Dealer</option>

            </select>

          </div>

          <button>

            Search Now

          </button>

        </div>

      </section>




      {/* =====================================
          FEATURED PROFESSIONALS
      ===================================== */}

      <section className="cc-find-professionals">

        <div className="cc-find-heading">

          <h2>Featured Professionals</h2>

          <p>

            Meet our verified experts with years of experience.

          </p>

        </div>

        <div className="cc-find-grid">




          {/* CARD 1 */}

          <div className="cc-find-card">

            <img
              src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=600"
              alt=""
            />

            <div className="cc-find-content">

              <h3>Rahul Sharma</h3>

              <span>Property Consultant</span>

              <div className="cc-find-rating">

                <FaStar/>
                <FaStar/>
                <FaStar/>
                <FaStar/>
                <FaStar/>

              </div>

              <p>

                Helping clients buy and sell premium
                residential properties with transparency.

              </p>

              <div className="cc-find-contact">

                <p>

                  <FaPhoneAlt/>

                  +91 9876543210

                </p>

                <p>

                  <FaEnvelope/>

                  info@InteriorMart.com

                </p>

              </div>

              <button>

                View Profile

                <FaArrowRight/>

              </button>

            </div>

          </div>

                    {/* CARD 2 */}

          <div className="cc-find-card">

            <img
              src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=600"
              alt=""
            />

            <div className="cc-find-content">

              <h3>Priya Verma</h3>

              <span>Interior Designer</span>

              <div className="cc-find-rating">
                <FaStar/>
                <FaStar/>
                <FaStar/>
                <FaStar/>
                <FaStar/>
              </div>

              <p>
                Luxury interiors, modular kitchens,
                office spaces and premium home décor
                solutions with modern designs.
              </p>

              <div className="cc-find-contact">

                <p>
                  <FaPhoneAlt/>
                  +91 9123456780
                </p>

                <p>
                  <FaEnvelope/>
                  priya@InteriorMart.com
                </p>

              </div>

              <button>

                View Profile

                <FaArrowRight/>

              </button>

            </div>

          </div>



          {/* CARD 3 */}

          <div className="cc-find-card">

            <img
              src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=600"
              alt=""
            />

            <div className="cc-find-content">

              <h3>Amit Kapoor</h3>

              <span>Architect</span>

              <div className="cc-find-rating">

                <FaStar/>
                <FaStar/>
                <FaStar/>
                <FaStar/>
                <FaStar/>

              </div>

              <p>
                Residential and commercial architecture
                with innovative planning and sustainable
                building concepts.
              </p>

              <div className="cc-find-contact">

                <p>
                  <FaPhoneAlt/>
                  +91 9988776655
                </p>

                <p>
                  <FaEnvelope/>
                  amit@InteriorMart.com
                </p>

              </div>

              <button>

                View Profile

                <FaArrowRight/>

              </button>

            </div>

          </div>

        </div>

      </section>



      {/* =====================================
            WHY CHOOSE OUR PROFESSIONALS
      ===================================== */}

      <section className="cc-find-why">

        <div className="cc-find-heading">

          <h2>Why Choose Our Professionals</h2>

          <p>

            Trusted experts delivering quality service,
            verified profiles and customer satisfaction.

          </p>

        </div>

        <div className="cc-find-why-grid">

          <div className="cc-find-why-card">

            <h3>✔ Verified Experts</h3>

            <p>
              Every professional is carefully verified
              before joining our platform.
            </p>

          </div>

          <div className="cc-find-why-card">

            <h3>✔ Experienced Team</h3>

            <p>
              Years of experience in real estate,
              construction and interior projects.
            </p>

          </div>

          <div className="cc-find-why-card">

            <h3>✔ Trusted Reviews</h3>

            <p>
              Genuine customer reviews help you choose
              the best professional confidently.
            </p>

          </div>

          <div className="cc-find-why-card">

            <h3>✔ Affordable Pricing</h3>

            <p>
              Compare multiple professionals and
              select according to your budget.
            </p>

          </div>

        </div>

      </section>

            {/* =====================================
              STATISTICS SECTION
      ===================================== */}

      <section className="cc-find-counter">

        <div className="cc-find-counter-box">

          <h2>500+</h2>

          <p>Verified Professionals</p>

        </div>

        <div className="cc-find-counter-box">

          <h2>1500+</h2>

          <p>Successful Projects</p>

        </div>

        <div className="cc-find-counter-box">

          <h2>98%</h2>

          <p>Happy Clients</p>

        </div>

        <div className="cc-find-counter-box">

          <h2>24/7</h2>

          <p>Customer Support</p>

        </div>

      </section>



      {/* =====================================
              CALL TO ACTION
      ===================================== */}

      <section
        className="cc-find-cta"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1920&q=80')",
        }}
      >

        <div className="cc-find-cta-overlay">

          <h2>
            Are You a Real Estate Professional?
          </h2>

          <p>
            Join InteriorMart and connect with thousands of
            customers looking for trusted real estate experts,
            builders, architects and interior designers.
          </p>

          <div className="cc-find-cta-btns">

            <button className="cc-find-btn-one">
              Register Now
            </button>

            <button className="cc-find-btn-two">
              Contact Us
            </button>

          </div>

        </div>

      </section>

    </>
  );
}

export default FindProfessional;